import { LitElement, html, svg } from 'lit';

export class IconClock24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Klokke</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M12 6v7.5l5 2.5"></path><path stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5" d="M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25Z"></path></svg>`; }
}
if (!customElements.get('f-icon-clock24', IconClock24)) {
  customElements.define('f-icon-clock24', IconClock24);
}